import type { SetupCatalog } from "src/api/types/SetupCatalog";

/*
 * This regex pattern matches URLs like
 *
 * https://github.com/platformsh/template-builder/blob/master/templates/framework-name/.platform.template.yaml
 *                    |                                                 |__ Group 2 _| |______ Group 3 ______|
 *                    |                                                                                      |
 *                    |______________________________________ Group 1 _______________________________________|
 *
 * Capturing Groups:
 * - Group 1: Captures the entire path after "https://raw.githubusercontent.com/", "https://github.com/" or "https://master-{organization_id}-{project_id}.{region}.platform.sh/catalog/".
 * - Group 2: Captures the second-to-last segment of the path (e.g., the branch name).
 * - Group 3: Captures the last segment of the path before ".template.yaml" (e.g., the file name without the extension).
 *
 * Examples:
 * - Match: "https://raw.githubusercontent.com/user/repo/branch/.platform.template.yaml"
 *   - Group 1: "user/repo/branch/.template.yaml"
 *   - Group 2: "branch"
 *   - Group 3: ".platform"
 * - Match: "https://github.com/user/repo/branch/file.template.yaml"
 *   - Group 1: "user/repo/branch/file.template.yaml"
 *   - Group 2: "branch"
 *   - Group 3: "file"
 * - Non-Match: "https://github.com/user/repo/branch/file.yaml" (does not end with ".template.yaml")
 * - Non-Match: "http://github.com/user/repo/branch/file.template.yaml" (does not start with "https://")
 * - Match Vendor Catalog:
 *   - Group 1: https://master-{organization_id}-{project_id}.{region}.platform.sh/catalog/file.yaml
 */
const regex =
  /^https:\/\/(?:raw\.githubusercontent|github)\.com\/((?:[\w.-]+\/){2,}([\w.-]+)\/([\w.-]+)\.template.yaml)$|^https:\/\/master-[\w-]+\.eu\.platform\.sh\/(catalog)\/([\w.-]+)\.yaml$/;

const getTemplateInfo = (
  url: string
): { path: string; name: string } | undefined => {
  const match = url.match(regex);

  if (!match) return undefined;

  // When the url's domain is https://raw.githubusercontent.com or master-{organization_id}-{project_id}.{region}.platform.sh/catalog,
  // it doesn't contain "blob/"
  return {
    path: match[1] ? match[1].replace("blob/", "") : match[0],
    name: match[3] !== ".platform" ? match[3] : match[2]
  };
};

const findtemplate = (
  templateUrl: string | undefined = "",
  templates: SetupCatalog[]
): { image?: string; name: string } | undefined => {
  const tplInfo = getTemplateInfo(templateUrl);
  if (!tplInfo) return undefined;

  const template = templates.find(elt => {
    const eltInfo = getTemplateInfo(elt.template);
    if (!eltInfo) return;

    return eltInfo.path === tplInfo.path || elt.info.id?.endsWith(tplInfo.name);
  });

  if (template)
    return {
      image: template.info.image,
      name: template.info.name
    };

  return {
    name: tplInfo.name
  };
};

export default findtemplate;
